/* eslint-disable camelcase */
import qs, { ParsedQs } from 'qs';

import { getFutureDateRange } from 'timeline/utils/getFutureDateRange';
import { getPresentDateRange } from 'timeline/utils/getPresentDateRange';
import { startCase } from 'shared/utils/startCase';

interface IFilters {
  designer?: string[];
  discount_tag?: string[];
  group_id?: string | string[] | ParsedQs | ParsedQs[];
  instant_ship_lowest_price_cents?: string;
  product_condition?: string;
  release_date?: string;
  technology?: string;
  upper_material?: string;
}

export const getSearchStateFromUrl = (query, pathname) => {
  const q = qs.parse(query);
  const { designerValue, pageSlug, productSlug, subCategory, technologyValue, upperMaterialValue } =
    q;
  const sort: any = {};
  const filters: IFilters = {};
  const filterKeys = new Set([
    'brand',
    'color',
    'designer',
    'discount_tag',
    'gender',
    'group_id',
    'has_image',
    'instant_ship_lowest_price_cents',
    'is_in_stock',
    'lowest_price_cents',
    'lowest_price_cents_bucket',
    'product_condition',
    'recently_released',
    'release_date',
    'release_date_year',
    'release_date_year_bucket',
    'size_converted',
    'special_type',
    'web_groups',
  ]);
  const sortKeys = new Set(['sortBy', 'sortOrder']);

  // timeline
  // Note: we need to place this before the for loop so that the Upcoming Releases `release_date` filter
  // overrides the `release_date` range
  if (pathname === '/timeline') {
    filters.release_date = `${getPresentDateRange().min}-${getPresentDateRange().max}`;
  }

  if (pathname === '/timeline/future') {
    filters.release_date = `${getFutureDateRange().min}-${getFutureDateRange().max}`;
  }

  for (const [key, value] of Object.entries(q)) {
    if (sortKeys.has(key)) {
      sort[key] = value;
    } else if (filterKeys.has(key)) {
      filters[key] = value;
    }
  }

  /*
   * There are instances where sort is not defined
   * this sets defaults as a bugsnag error complains
   * about sort_order sending an invalid value
   */

  if (!sort?.sortBy) {
    sort.sortBy = 'relevance';
  }
  if (!sort?.sortOrder) {
    sort.sortOrder = 'descending';
  }

  /**
   * pageSlug is a category, and subCategory is just that
   * when there is a pageSlug, we filter on that, but if there
   * is a more specific value (like subCategory) it should override
   * the pageSlug
   */
  if (pageSlug || subCategory || productSlug) {
    filters.group_id = productSlug || subCategory || pageSlug;
  }

  if (designerValue) {
    filters.designer = startCase(designerValue as string, true).toLowerCase();
  }

  if (upperMaterialValue) {
    filters.upper_material = startCase(upperMaterialValue as string, true).toLowerCase();
  }

  if (technologyValue) {
    filters.technology = startCase(technologyValue as string, true).toLowerCase();
  }

  // Goat Clean
  if (pathname === '/goat-clean') {
    filters.product_condition = 'goat_clean';
  }

  // Instant Ship
  if (pathname === '/instant') {
    const DEFAULT_LARGE_INSTANT_SHIP_RANGE = '0 - 100000000000';
    filters.instant_ship_lowest_price_cents = DEFAULT_LARGE_INSTANT_SHIP_RANGE;
  }

  // Under Retail
  if (pathname === '/sneakers/under-retail') {
    filters.discount_tag = ['under_retail'];
  }

  return Object.keys(filters).length > 0 ? { ...sort, filters: { ...filters } } : sort;
};
